import React, { useState } from "react";
import Dashboard1 from "../../components/Dashboard/Dashboard1";
import Dashboard2 from "../../components/Dashboard/Dashboard2";

export default function Dashboard() {
  const [userStatus, setUserStatus] = useState(true);

  return <div>{userStatus ? <Dashboard2 /> : <Dashboard1 />}</div>;
}
